var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.223 9.063v4.203h6.11c-.798 2.546-2.97 4.37-6.11 4.37-3.738 0-6.77-2.972-6.77-6.636s3.032-6.635 6.77-6.635c1.681 0 3.216.604 4.4 1.598l3.158-3.095C16.787 1.087 14.134 0 11.224 0 5.023 0 0 4.925 0 11s5.025 11 11.223 11c9.422 0 11.501-8.635 10.578-12.923l-10.577-.014z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.75e2417d9d3ab209688a4ec3e0ca79a2.svg";
export { ForwardRef as ReactComponent };